import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, renderSlot as _renderSlot, vShow as _vShow, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Transition as _Transition, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "strategy-brief-hub-step-layout" }
const _hoisted_2 = { slot: "template-main" }
const _hoisted_3 = { "no-margin": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VJoyButton = _resolveComponent("VJoyButton")!
  const _component_VJoyHeader = _resolveComponent("VJoyHeader")!
  const _component_progress_tracker_v2 = _resolveComponent("progress-tracker-v2")!
  const _component_VJoyFunnelFooter = _resolveComponent("VJoyFunnelFooter")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!
  const _component_VJoyTemplate = _resolveComponent("VJoyTemplate")!
  const _component_VJoyFunnel = _resolveComponent("VJoyFunnel")!

  return (_openBlock(), _createBlock(_component_VJoyFunnel, { "layout-width": "large" }, {
    "funnel-header": _withCtx(() => [
      _createVNode(_component_VJoyHeader, null, _createSlots({
        "header-left": _withCtx(() => [
          _createVNode(_component_VJoyButton, {
            slot: "header-left",
            icon: "cross",
            variant: "ghost",
            circle: "",
            onClick: _ctx.goToReferrer
          }, null, 8, ["onClick"])
        ]),
        _: 2
      }, [
        (!_ctx.$features.projectProposalBriefNoMoreServiceLevelNeeded)
          ? {
              name: "header-right",
              fn: _withCtx(() => [
                (_ctx.isUnloggedOrStandardUser)
                  ? (_openBlock(), _createBlock(_component_VJoyButton, {
                      key: 0,
                      "data-testid": "service-level-upgrade-button",
                      onClick: _ctx.upgradeServiceLevel
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.upgrade.service.level')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              key: "0"
            }
          : undefined
      ]), 1024)
    ]),
    "funnel-stepper": _withCtx(() => [
      _createVNode(_component_progress_tracker_v2)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_VJoyWrapper, {
          direction: "column",
          align: "stretch"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VJoyTemplate, {
              sidebar: "right",
              class: "strategy-layout__template"
            }, {
              "template-title": _withCtx(() => [
                _createVNode(_Transition, { name: "slide-fade" }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createElementBlock("h1", {
                      key: _ctx.$route.path,
                      class: "step__main-title"
                    }, [
                      _renderSlot(_ctx.$slots, "title", {}, undefined, true)
                    ])), [
                      [_vShow, _ctx.$route.path]
                    ])
                  ]),
                  _: 3
                })
              ]),
              "template-main": _withCtx(() => [
                _createVNode(_component_VJoyWrapper, {
                  direction: "column",
                  align: "stretch"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                    ]),
                    (_ctx.hasFooter)
                      ? (_openBlock(), _createBlock(_component_VJoyFunnelFooter, { key: 0 }, {
                          "footer-left": _withCtx(() => [
                            (_ctx.previousAvailable)
                              ? (_openBlock(), _createBlock(_component_VJoyButton, {
                                  key: 0,
                                  label: _ctx.$msg('customer.brief.exec.form.link.previous'),
                                  variant: "secondary",
                                  onClick: _ctx.goToPreviousStep
                                }, null, 8, ["label", "onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          "footer-right": _withCtx(() => [
                            (_ctx.briefComplete)
                              ? (_openBlock(), _createBlock(_component_VJoyButton, {
                                  key: 0,
                                  slot: "footer-right",
                                  label: _ctx.$msg('general.validate'),
                                  disabled: !_ctx.isFormValid || _ctx.loading,
                                  size: _ctx.isMobile ? 'small' : 'medium',
                                  onClick: _ctx.backToOverview
                                }, null, 8, ["label", "disabled", "size", "onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.showNext)
                              ? (_openBlock(), _createBlock(_component_VJoyButton, {
                                  key: 1,
                                  slot: "footer-right",
                                  label: _ctx.$msg('customer.brief.exec.form.link.next'),
                                  variant: "main",
                                  class: _normalizeClass({next: !_ctx.previousAvailable}),
                                  disabled: !_ctx.isFormValid || _ctx.loading,
                                  "data-testid": "search_plus_brief_next",
                                  onClick: _ctx.onFormSubmit
                                }, null, 8, ["label", "class", "disabled", "onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 3
                })
              ]),
              "template-sidebar": _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _renderSlot(_ctx.$slots, "right", {}, undefined, true)
                ])
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ])
    ]),
    _: 3
  }))
}